module.exports = __webpack_public_path__ + "static/media/4.0a61b848.mp4";